import "./VideoTutorial.scss";
import React, { useEffect, useState } from "react";
import { StateSetter } from "../utils/types";
import Tray from "./Tray";
import { VideoInfo } from "./videoTutorialUtils";

interface VideoTutorialTrayProps {
  showVideoTray: boolean;
  setShowVideoTray: StateSetter<boolean>;
  videoList: VideoInfo[] | undefined;
}

const VideoTutorialTray: React.FC<VideoTutorialTrayProps> = ({
  showVideoTray,
  setShowVideoTray,
  videoList,
}) => {
  const [videoContentList, setVideoContentList] = useState<VideoInfo[]>([]);

  useEffect(() => {
    if (videoList) {
      setVideoContentList(videoList);
    }
  }, [videoList]);

  return showVideoTray ? (
    <Tray setShowExpandedTray={setShowVideoTray} videoList={videoContentList}></Tray>
  ) : null;
};

export default VideoTutorialTray;
